import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import {
  SyncBetsoftBonusPayload,
  SyncBetsoftBonusResponse,
  WalletState,
} from '../models'

import { WALLET } from './api.routes'

const restApiService: RestApiService = Container.get(RestApiService)

export const syncBetsoftBonusThunk = createAsyncThunk(
  ActionTypes.SYNC_BETSOFTBONUS,
  async (payload: SyncBetsoftBonusPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: WALLET.SYNC_BETSOFTBONUS,
        queries: jsonToQueryString(payload),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: SyncBetsoftBonusResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('wallet.syncBetsoftBonusMessage')

      if (Number(response.status) === 500) {
        message =
          response?.message && typeof response?.message === 'string'
            ? response?.message
            : i18n.t('messages.errorOccurred')
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: Number(response.status) === 500 ? 'error' : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const syncBetsoftBonusExtraReducer = (
  builder: ActionReducerMapBuilder<WalletState>,
) => {
  builder.addCase(syncBetsoftBonusThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(syncBetsoftBonusThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false

    const newWallet = state.wallets.map((wallet) => {
      if (wallet.id === payload.id) {
        return {
          bonusName: wallet.bonusName,
          ...payload,
        }
      } else {
        return wallet
      }
    })

    state.wallets = newWallet
    state.isLoading = false
  })
  builder.addCase(syncBetsoftBonusThunk.rejected, (state) => {
    state.isLoading = false
  })
}

export default syncBetsoftBonusExtraReducer
